import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ReadingProgress() {
  const [progress, setProgress] = useState(0);
  const location = useLocation();

  // Only show on blog post pages (/blog/:slug)
  const isBlogPost = /^\/blog\/[^/]+$/.test(location.pathname);

  useEffect(() => {
    if (!isBlogPost) return;

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) {
        setProgress(0);
        return;
      }
      setProgress(Math.min((scrollTop / docHeight) * 100, 100));
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isBlogPost]);

  if (!isBlogPost) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] h-1 bg-muted/50" role="progressbar" aria-valuenow={Math.round(progress)} aria-valuemin={0} aria-valuemax={100} aria-label="Reading progress">
      <div
        className="h-full bg-primary transition-[width] duration-150 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}
